import React,{useState} from 'react'
import { Outlet } from 'react-router-dom'
import SideBar from '../Components/Admin/SideBar.js'
import Header from '../Components/Admin/Header.js'
import './Dashboard.css'

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <div>
    <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100vh' }} >
      <Header toggleSidebar={toggleSidebar} />
      <div style={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }} className="main">
        <div className={`overlay ${isSidebarOpen ? 'active' : ''}`} onClick={toggleSidebar} />

        <div className={`sidebar ${isSidebarOpen ? 'active' : ''}`}>
          <SideBar toggleSidebar={toggleSidebar} />
        </div>

        <div style={{ flexGrow: 1, overflowY: 'auto' }} className={`content ${isSidebarOpen ? 'sidebar-open' : ''}`}>
          <Outlet />
        </div>
      </div>
    </div>
    </div>
    
  )
}

export default Dashboard;